import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@material-ui/core';
import cx from 'classnames';
import { CloseIcon } from 'sharedComponents/Icons';
import { getFilterLabels as getGroupPageFilterLabels } from './filterUtils';
import { GroupClientsFiltersPropTypes } from '../../utils';

const FilterChips = ({ classes, filters, chipsObject, setFilters, getFilterLabels, withoutTopPadding }) => {
  const labels = React.useMemo(() => getFilterLabels(filters), [filters]);
  const onDeleteChipHandler = (label) => {
    if (label.clear) {
      label.clear(filters, setFilters);
    }
  };

  return (
    <div className={cx(!withoutTopPadding || classes.topPadding, classes.container)}>
      {labels.map((label) => (
        <Chip
          key={label.label}
          data-testid="chip"
          label={chipsObject[label.label] ? chipsObject[label.label] : label.label}
          deleteIcon={<CloseIcon onClick={() => onDeleteChipHandler(label)} />}
          classes={{ deleteIcon: classes.deleteIcon, root: classes.chipRoot }}
          onDelete={() => onDeleteChipHandler(label)}
          className={classes.chip}
        />
      ))}
      <div className={classes.placeholder} />
    </div>
  );
};

FilterChips.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  filters: GroupClientsFiltersPropTypes,
  setFilters: PropTypes.func,
  getFilterLabels: PropTypes.func,
  withoutTopPadding: PropTypes.bool,
  chipsObject: PropTypes.shape({}),
};

FilterChips.defaultProps = {
  withoutTopPadding: false,
  classes: {},
  filters: {},
  chipsObject: {},
  getFilterLabels: getGroupPageFilterLabels,
};

export default FilterChips;
